import { Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { EInvoiceIcon } from "./icons/EInvoiceIcon"

export const EInvoiceTag = ({ className = "flex items-center " }: { className?: string }) => {
    const { t } = useTranslation()
    return (
        <Tag color="purple" icon={<EInvoiceIcon />} className={className}>
            {t("label:e_invoice")}
        </Tag>
    )
}
